import { useAppsMenuStore } from '../context/AppsMenuContext';
import { useAppSettings } from './useAppSettings';
import useApi from '../api/useApi';

/**
 * Custom hook for fetching apps menu HTML
 * Products are loaded on-demand using QueryProductMetaData in ProductsList
 */
const useGetAppsMenu = () => {
    const { getApiData } = useApi();
    const { setAppsMenu, setIsLoading: setAppsMenuLoading } = useAppsMenuStore();
    const { settings: appSettings } = useAppSettings();

    /**
     * Fetches the apps menu HTML from the API and stores it in context
     * Non-blocking - failures won't stop app load
     */
    const getAppsMenu = async () => {
        try {
            const apiUrl = appSettings?.api;
            if (!apiUrl) {
                console.warn('[useGetAppsMenu] API URL not configured, skipping apps menu load');
                return;
            }

            console.log('[useGetAppsMenu] Fetching apps menu...');
            setAppsMenuLoading(true);

            const response = await getApiData({
                endpoint: `${apiUrl}GetAppsDataHtml`,
            });

            setAppsMenu(response);
        } catch (error) {
            console.error('[useGetAppsMenu] Error fetching apps menu (non-critical):', error);
        } finally {
            setAppsMenuLoading(false);
        }
    };

    return { getAppsMenu };
};

export default useGetAppsMenu;
